export default __webpack_public_path__ + "static/media/youmLogo.3a1912ce.png";